import { Component, OnInit , ViewChild,ChangeDetectorRef} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, ActivatedRoute } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { TableService } from '../services/pager/pager';
import { DatePipe } from '@angular/common';
import { WebService } from '../services/web/web.service';
import { SpinnerService } from '../services/spinner/spinner.service';
import { ToastService } from '../services/notification/toast.service';
import { TranslateService } from '@ngx-translate/core';
import { InvoiceRefundView } from './invoice-refund-view.model';
import { formatStrictAmount, parseStrictAmount } from '../utils/strict-amount';
import { MatDialog } from '@angular/material/dialog';
import { RefundReceiptDialogComponent } from './refund-receipt-dialog/refund-receipt-dialog.component';

@Component({
    selector: 'app-customer-invoice-detail',
    templateUrl: './customer-invoice-detail.component.html',
    styleUrls: ['./customer-invoice-detail.component.scss'],
    providers: [DatePipe],
    standalone: false
})
export class CustomerInvoiceDetailComponent implements OnInit {

  invoice : any;
  items: any[] = [];
  successfulPayment: any | null = null;
  successfulPaymentLoading = false;
  successfulPaymentLoaded = false;
  dataSource: any;
  dataCuponSource: any;
  cupons: any[] = [];
  currency : any = null;
  displayedColumns: string[] = [ 'id', 'description_payment', 'resultStatus_payment', 'dates','card','transaction','transactionRefundId','amount_payment', 'actions'];
  displayedCuponColumns: string[] = [ 'cupon.id', 'cupon.name_cupon', 'cupon.value', 'cupon.type', 'cupon.status','cupon.createdAt'];

  // ─── Historial de reembolsos (ledger read-only, carga aislada) ─────────────
  refunds: InvoiceRefundView[] = [];
  refundDataSource = new MatTableDataSource<InvoiceRefundView>([]);
  refundTableService = new TableService<InvoiceRefundView>();
  refundDisplayedColumns: string[] = ['createdAt', 'amount', 'refundType', 'status', 'authorizationNumber', 'resolvedAt', 'processorRefundId', 'actions'];
  refundsLoading = false;
  refundsLoadError = false;
  invoiceStatusValue: number | null = null;
  invoiceId!: number;

  // Solo digitos al final de la mascara (hasta 4); 'XXXX' o digitos de BIN seguidos de X no cuentan.
  private static readonly TRAILING_CARD_DIGITS = /(\d{1,4})$/;

  private static readonly REFUND_TYPE_KEYS: Record<string, string> = {
    FULL: 'customerInvoiceDetail.refunds.types.full',
    PARTIAL: 'customerInvoiceDetail.refunds.types.partial'
  };

  private static readonly REFUND_STATUS_KEYS: Record<string, string> = {
    SUCCEEDED: 'customerInvoiceDetail.refunds.statuses.succeeded',
    PENDING: 'customerInvoiceDetail.refunds.statuses.pending',
    UNKNOWN: 'customerInvoiceDetail.refunds.statuses.unknown',
    FAILED: 'customerInvoiceDetail.refunds.statuses.failed'
  };

  private static readonly LEGACY_REFUND_STATUS = 18;

  constructor(
    public  tableService: TableService<any>,
    private activatedRoute: ActivatedRoute,
    private datePipe : DatePipe,
    public tableCuponService: TableService<any>,
    private router: Router,
    private cdr: ChangeDetectorRef,private webService : WebService,private spinner : SpinnerService,private toast : ToastService,
    private translate: TranslateService,
    private dialog: MatDialog) {
      this.tableService = new TableService;
    }

    copyValue(value: string): void {
      const showCopyError = () => this.toast.showError(this.translate.instant('customerInvoiceDetail.payments.labels.copyError'));

      if (!navigator.clipboard?.writeText) {
        showCopyError();
        return;
      }

      navigator.clipboard
        .writeText(value)
        .then(() => this.toast.showSuccess(this.translate.instant('customerInvoiceDetail.payments.labels.copied')))
        .catch(showCopyError);
    }

    ngOnInit(): void {
      this.spinner.open()
      this.activatedRoute.params.subscribe( params =>{
        this.invoiceId = +params["invoice"];
        this.successfulPayment = null;
        this.successfulPaymentLoading = false;
        this.successfulPaymentLoaded = false;
        this.webService.get( this.webService.HOST + "/invoice/" +params["invoice"]).subscribe(invoice => {  // BUSCAMOS LA FACTURA
          this.invoice = invoice.result;
          this.invoiceStatusValue = this.invoice.status_invoice; // valor numerico antes de reemplazarlo por la descripcion
          this.listRefunds();

          this.invoice.dateCreated_invoice = this.formatStoredDate(this.invoice.createdAt);
          this.invoice.updatedAt = this.formatStoredDate(this.invoice.updatedAt);


          this.currency = this.invoice?.currencyBase?.codeCurrency;
            this.webService.get(this.webService.HOST + "/invoice/status/" + this.invoice.status_invoice).subscribe(status =>{ // BUSCAMOS SU ESTATUS
              this.invoice.status_invoice = status.result.description;
              this.list();
                  this.webService.get(this.webService.HOST + "/cupon/invoice/" + this.invoice.id,this.webService.buildRequestParams()).subscribe(cupons=>{
                    this.spinner.open();
                    this.cupons = cupons['result'];
                    for(const c of this.cupons){
                      c.cupon.status = c.cupon.status === 1 ? 'Activo' : 'Inactivo';
                      c.cupon.type = c.cupon.type === 1 ? '%' : '$';
                    }
                    this.dataCuponSource = new MatTableDataSource<any>(this.cupons);
                    this.tableCuponService.pager = cupons['pager'];
                    this.tableCuponService.selection.clear();
                    this.spinner.close();

              }, err =>{
                this.toast.showError(err);
                this.spinner.close();
              })
            }, err =>{
              this.toast.showError(err);
              this.spinner.close();
            });
          }, err=>{
            this.toast.showError(err);
            this.spinner.close();
          });


      }, err =>{
        this.toast.showError(err);
      })
    }

    /**
     * Detecta automáticamente el formato de fecha basándose en los primeros 4 dígitos
     * @param dateStr - String de fecha en formato MMddyyyy o yyyyMMdd
     * @returns 'MMddyyyy' o 'yyyyMMdd'
     */
    detectDateFormat(dateStr: string): 'MMddyyyy' | 'yyyyMMdd' {
      if (!dateStr || dateStr.length !== 8) {
        return 'MMddyyyy'; // Fallback por defecto
      }
      
      const firstFour = parseInt(dateStr.substring(0, 4), 10);
      
      // Si los primeros 4 dígitos son > 1231, es un año (formato yyyyMMdd)
      // Si son <= 1231, es mes+día (formato MMddyyyy)
      // 1231 es el máximo valor posible de MMdd (31 de diciembre)
      return firstFour > 1231 ? 'yyyyMMdd' : 'MMddyyyy';
    }

    /**
     * Formatea hostDate y hostTime en un string de fecha legible
     * @param hostDate - Fecha en formato MMddyyyy o yyyyMMdd
     * @param hostTime - Hora en formato HHmmss
     * @returns String formateado como 'yyyy-MM-dd HH:mm:ss' o null
     */
    formatTransactionDate(hostDate: string, hostTime: string): string | null {
      if (!hostDate) {
        return null;
      }

      try {
        const dateStr = hostDate.toString();
        const format = this.detectDateFormat(dateStr);
        let year: string, month: string, day: string;

        if (format === 'yyyyMMdd') {
          // Formato: yyyyMMdd (ejemplo: 20250827)
          year = dateStr.substring(0, 4);
          month = dateStr.substring(4, 6);
          day = dateStr.substring(6, 8);
        } else {
          // Formato: MMddyyyy (ejemplo: 12122025)
          month = dateStr.substring(0, 2);
          day = dateStr.substring(2, 4);
          year = dateStr.substring(4, 8);
        }

        // Formatear hora si existe
        let timeStr = '00:00:00';
        if (hostTime && hostTime.toString().length === 6) {
          const time = hostTime.toString();
          const hours = time.substring(0, 2);
          const minutes = time.substring(2, 4);
          const seconds = time.substring(4, 6);
          timeStr = `${hours}:${minutes}:${seconds}`;
        }

        return `${year}-${month}-${day} ${timeStr}`;
      } catch (error) {
        console.error('Error formateando transactionDate:', error);
        return null;
      }
    }

    list(event?: PageEvent) {
      this.spinner.open()
      let httpParams = this.webService.buildRequestParams(this.tableService.sort,"m",
      {pageIndex: event ? event.pageIndex : this.tableService.pager.pageIndex , pageSize: event ? event.pageSize : this.tableService.pager.pageSize})

      this.webService.get(this.webService.HOST + "/payment/list/" + this.invoice.id ,httpParams).subscribe(params => {
        this.items = params['result'];
        for(let p of this.items){ // BUSCAMOS LA DESCRIPCION DEL CODIGO DE LOS PAYMENTS
              this.preparePayment(p);
              
        }
        this.spinner.close();
            this.dataSource = new MatTableDataSource<any>(this.items);
            this.tableService.pager = params['pager'];
            this.tableService.selection.clear();
            this.loadSuccessfulPayment();
          }, err => {
            this.spinner.close();
            this.toast.showError(err);
          });
      }

    goBack(){
      this.router.navigate(["/reports"]); 
    }

    listCupon(event?: PageEvent) {
    }

    openRefundReceipt(payment: any): void {
      if (!payment?.hasRefund) {
        return;
      }
      this.dialog.open(RefundReceiptDialogComponent, {
        width: '680px',
        maxWidth: 'calc(100vw - 32px)',
        maxHeight: 'calc(100vh - 32px)',
        data: {
          invoice: this.invoice,
          payment,
          currency: this.currency,
          refundAuthorizationUnavailableLabel: this.translate.instant('customerInvoiceDetail.refundReceipt.unavailable'),
        },
      });
    }

    openRefundReceiptFromHistory(refund: InvoiceRefundView): void {
      const refundTypeKey = this.refundTypeKey(refund.refundType);

      this.dialog.open(RefundReceiptDialogComponent, {
        width: '680px',
        maxWidth: 'calc(100vw - 32px)',
        maxHeight: 'calc(100vh - 32px)',
        data: {
          invoice: this.invoice,
          payment: this.successfulPayment,
          refund,
          refundTypeLabel: refundTypeKey ? this.translate.instant(refundTypeKey) : null,
          refundStatusLabel: this.translate.instant(this.refundStatusKey(refund.status)),
          refundAuthorizationUnavailableLabel: this.translate.instant('customerInvoiceDetail.refundReceipt.unavailable'),
          currency: refund.currency ?? this.currency,
        },
      });
    }

    canShowLegacyReceipt(payment: any): boolean {
      return !!payment?.hasRefund
        && !this.refundsLoading
        && (this.refundsLoadError || this.refunds.length === 0);
    }

    canShowRefundReceipt(refund: InvoiceRefundView): boolean {
      return String(refund?.status ?? '').toUpperCase() === 'SUCCEEDED';
    }

    /**
     * Carga aislada del ledger: NO abre/cierra el spinner global para que un
     * error del historial no bloquee datos generales, payments ni cupones.
     */
    listRefunds(event?: PageEvent): void {
      this.refundsLoading = true;
      this.refundsLoadError = false;

      const httpParams = this.webService.buildRequestParams(this.refundTableService.sort, 'm', {
        pageIndex: event ? event.pageIndex : this.refundTableService.pager.pageIndex,
        pageSize: event ? event.pageSize : this.refundTableService.pager.pageSize
      });

      const url = this.webService.HOST + '/invoice/' + this.invoiceId + '/refunds';

      this.webService.get(url, httpParams).subscribe(response => {
        this.refunds = response['result'] ?? [];
        this.refundDataSource = new MatTableDataSource<InvoiceRefundView>(this.refunds);
        this.refundTableService.pager = response['pager'];
        this.refundsLoading = false;
      }, () => {
        // Error aislado: no registrar el payload HTTP crudo del ledger.
        this.refunds = [];
        this.refundDataSource = new MatTableDataSource<InvoiceRefundView>([]);
        this.refundsLoading = false;
        this.refundsLoadError = true;
        this.toast.showError(this.translate.instant('customerInvoiceDetail.refunds.loadError'));
      });
    }

    private getSuccessfulPayment(payments: any[] = this.items): any | null {
      return payments.find(payment => String(payment.resultStatus_payment) === '00') ?? null;
    }

    private loadSuccessfulPayment(): void {
      if (this.successfulPaymentLoading || this.successfulPaymentLoaded) {
        return;
      }

      this.successfulPaymentLoading = true;
      const httpParams = this.webService.buildRequestParams(undefined, 'm', {
        pageIndex: -1,
        pageSize: -1,
      });

      this.webService.get(this.webService.HOST + '/payment/list/' + this.invoice.id, httpParams).subscribe(response => {
        this.successfulPayment = this.getSuccessfulPayment(response['result'] ?? []);
        if (this.successfulPayment) {
          this.preparePayment(this.successfulPayment);
        }
        this.successfulPaymentLoaded = true;
        this.successfulPaymentLoading = false;
      }, () => {
        this.successfulPaymentLoaded = true;
        this.successfulPaymentLoading = false;
      });
    }

    private preparePayment(payment: any): void {
      payment.hasRefund = !!payment.transactionRefundId;
      payment.resultStatus_payment = payment.resultStatus_payment != null ? payment.resultStatus_payment : 'N/A';
      payment.transactionRefundId = payment.transactionRefundId != null ? payment.transactionRefundId : 'N/A';
      payment.description_payment = payment.result_description != null ? payment.result_description : payment.description_payment;
      payment.dateCreated_payment = this.formatStoredDate(payment.dateCreated_payment);
      payment.transactionDate = this.formatTransactionDate(payment.hostDate, payment.hostTime);
      this.setCardFields(payment);
    }

    // Ultimos 4 digitos y marca por separado; nunca expone la mascara completa.
    private setCardFields(payment: any): void {
      const last4 = this.extractLastDigits(payment?.cardMask) || this.extractLastDigits(payment?.token?.mask_card);
      if (!last4) {
        payment.cardLast4 = '—';
        payment.cardBrand = '';
        return;
      }

      payment.cardLast4 = last4;
      payment.cardBrand = this.resolveBrand(payment?.cardProvider) || this.resolveBrand(payment?.token?.creditCardProvider);
    }

    private extractLastDigits(mask: unknown): string {
      return String(mask ?? '').trim().match(CustomerInvoiceDetailComponent.TRAILING_CARD_DIGITS)?.[1] ?? '';
    }

    private resolveBrand(provider: unknown): string {
      const brand = typeof provider === 'object' && provider !== null ? (provider as any).description : provider;
      return typeof brand === 'string' ? brand.trim() : '';
    }

    private formatStoredDate(value: unknown): string | null {
      if (typeof value !== 'string' && typeof value !== 'number' && !(value instanceof Date)) {
        return null;
      }

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return null;
      }

      date.setHours(date.getHours() - 5);
      return this.datePipe.transform(date, 'yyyy-MM-dd HH:mm:ss');
    }

    // 0.00 solo para cero conocido; ausente/invalido se muestra como '—'.
    formatMoney(value: unknown): string {
      return formatStrictAmount(value);
    }

    // Neto cobrado = total original - reembolsado confirmado (SUCCEEDED).
    // Pendientes/fallidos NO reducen el neto; si falta algun operando o es
    // invalido (parser estricto), null -> el template muestra '—'.
    netCollectedAmount(): number | null {
      const totalNum = parseStrictAmount(this.invoice?.total_invoice);
      const refundedNum = parseStrictAmount(this.invoice?.refundedAmount);
      if (totalNum === null || refundedNum === null) return null;
      return Math.max(0, totalNum - refundedNum);
    }

    refundTypeKey(type: unknown): string | null {
      if (type === null || type === undefined) return null;
      return CustomerInvoiceDetailComponent.REFUND_TYPE_KEYS[String(type)] ?? null;
    }

    refundStatusKey(status: unknown): string {
      if (status === null || status === undefined) {
        return CustomerInvoiceDetailComponent.REFUND_STATUS_KEYS['UNKNOWN'];
      }
      return CustomerInvoiceDetailComponent.REFUND_STATUS_KEYS[String(status)]
        ?? CustomerInvoiceDetailComponent.REFUND_STATUS_KEYS['UNKNOWN'];
    }

    // Clase semantica del badge de estado; nunca depende solo del color
    // porque el texto traducido siempre acompana.
    refundStatusClass(status: unknown): string {
      const normalized = String(status ?? '').toUpperCase();
      return ['SUCCEEDED', 'PENDING', 'UNKNOWN', 'FAILED'].includes(normalized)
        ? normalized.toLowerCase()
        : 'unknown';
    }

    formatNetCollected(): string {
      const net = this.netCollectedAmount();
      return net === null ? '—' : net.toFixed(2);
    }

    // Facturas legacy cobradas antes del ledger (status 18) sin filas: mensaje
    // distinto del empty normal. Error/loading nunca cuentan como empty.
    showLegacyRefundEmptyState(): boolean {
      return this.invoiceStatusValue === CustomerInvoiceDetailComponent.LEGACY_REFUND_STATUS
        && !this.refundsLoading
        && !this.refundsLoadError
        && this.refunds.length === 0;
    }

}
